import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RadioGroupComponent, RadioOption } from '@woolworthsnz/form';
import { Subject, skip, takeUntil } from 'rxjs';

@Component({
	selector: 'recipe-meal-plan-dietary-preference',
	templateUrl: './meal-plan-dietary-preference.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [RadioGroupComponent, FormsModule, ReactiveFormsModule],
})
export class MealPlanDietaryPreferenceComponent implements OnDestroy {
	@Input() value: string;
	@Input() options: { key: number; text: string }[];

	@Output() valueChange = new EventEmitter<string[]>();
	public formGroup = new UntypedFormGroup({});
	private destroyed$: Subject<boolean> = new Subject();

	constructor() {
		this.onValueChange();
	}

	public ngOnDestroy(): void {
		this.destroyed$.next(true);
		this.destroyed$.complete();
	}

	public onValueChange(): void {
		this.formGroup?.valueChanges
			.pipe(takeUntil(this.destroyed$), skip(2)) // skips creation of form control with empty value and setting of the default value
			.subscribe((formValue) => {
				this.valueChange.emit([formValue['dietary-needs']]);
			});
	}

	public mapToValueAndLabel(options: { key: number; text: string }[]): RadioOption[] {
		return (options && options.map((option) => ({ value: String(option.key), label: option.text }))) || [];
	}
}
